import React from "react";
import Callout from "components/Callout";
import { STATE_KEYS } from "utils/constants/state";
import { PRODUCT_ORDER_INTENT } from "utils/constants/pricing";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import { useFormikContext } from "formik";
import Button from "components/Form/fields/Button";

const CreatePriceCallout = ({ priceLabel }) => {
  const { setFieldValue } = useFormikContext();
  const copy = priceLabel
    ? `No ${priceLabel} prices available.`
    : `No prices available.`;
  return (
    <Callout
      copy={copy}
      customClasses={{
        container:
          "flex flex-column ph2 ba br2 items-start b--black-10 pv2 w-100 justify-between"
      }}
    >
      <div className="pt2">
        <Button
          theme="slim"
          classes={{
            contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
          }}
          onClick={() => {
            setFieldValue(
              STATE_KEYS.EDITOR.PRODUCT_ORDER_INTENT,
              PRODUCT_ORDER_INTENT.PRICE_ADD
            );
          }}
          copy="Create price"
        />
      </div>
    </Callout>
  );
};
export default CreatePriceCallout;
